import React from 'react';

const AiLoader = () => {
	return (
		<div className="ai-loader">
			<span></span>
			<span></span>
			<span></span>
		</div>
	);
};

export default AiLoader;
